import React, {useRef, useState} from 'react';
import {FormGroup, Label, Input} from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import * as R from 'ramda';
import moment from 'moment';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/zh-tw';
import {useTranslation} from 'react-i18next';

import {useFieldState, ErrorTooltip} from '@/Form/index';
import '@/Form/datePicker.css';

const YearMonthForm = ({date, localeUtils, locale, setMonth, years}) => {
  const yearRef = useRef(null);
  const monthRef = useRef(null);
  const months = localeUtils.getMonths(locale);

  const handleChange = () => {
    setMonth(new Date(yearRef.current.value, monthRef.current.value));
  };

  return (
    <div className='DayPicker-Caption'>
      <select ref={yearRef} onChange={handleChange} value={date.getFullYear()}>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      <select ref={monthRef} onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
    </div>
  );
};

const captionElement = (setMonth, fromDate, toDate) => captionProps => {
  const years = R.range(fromDate.year(), toDate.year() + 1);

  return <YearMonthForm {...{setMonth, years}} {...captionProps} />;
};

const defaultRange = {
  from: moment()
    .subtract(5, 'years')
    .startOf('year'),
  to: moment()
    .add(5, 'years')
    .endOf('year'),
};

const DatePicker = ({id, name, label, ...rest}) => {
  const fieldState = useFieldState({id, name});
  const {errors, value, onChange, ...inputProps} = fieldState;
  const {id: target} = fieldState;
  const {t: tr, i18n} = useTranslation();
  const lang = i18n.language === 'kr' ? 'ko' : i18n.language;
  const [month, setMonth] = useState();
  const fromDate = R.propOr(defaultRange.from, 'fromDate', rest);
  const toDate = R.propOr(defaultRange.to, 'toDate', rest);

  const onDayChange = selectedDay => {
    onChange({
      target: {
        name,
        value: R.isNil(selectedDay)
          ? ''
          : formatDate(selectedDay, 'YYYY/MM/DD'),
      },
    });
  };

  return (
    <FormGroup>
      <Label htmlFor={target}>{label}</Label>

      <DayPickerInput
        placeholder=''
        format='YYYY/MM/DD'
        formatDate={formatDate}
        parseDate={parseDate}
        component={Input}
        value={value}
        onDayChange={onDayChange}
        inputProps={{autoComplete: 'off', ...inputProps}}
        dayPickerProps={{
          locale: lang,
          localeUtils: MomentLocaleUtils,
          todayButton: tr('today'),
          month,
          fromMonth: fromDate.toDate(),
          toMonth: toDate.toDate(),
          captionElement: captionElement(setMonth, fromDate, toDate),
        }}
      />
      <ErrorTooltip errors={errors} target={target} />
    </FormGroup>
  );
};

export default DatePicker;
